import { inject, Injectable } from '@angular/core';
import { AlertOptions, ConversationChannelService } from './conversation-channel.abstract';
import { InboxAlertService } from './inbox-alert.service';
import { Observable, of } from 'rxjs';
import { ConversationDetail } from '../interface/conversation.interface';
import { getMainConversationId } from './message-errors.util';

@Injectable()
export class ConversationPersonalEmailService extends ConversationChannelService {
  private readonly inboxAlerter = inject(InboxAlertService);

  getChatComposerAlert(
    _partnerId: string,
    _accountGroupId: string,
    conversationDetail: ConversationDetail,
  ): Observable<AlertOptions | null> {
    const mainConversationID = getMainConversationId(conversationDetail);
    if (mainConversationID !== '') {
      return of(this.inboxAlerter.getDuplicatedConversationError(mainConversationID));
    }
    return of(null);
  }
}
